<div class="p-6">
  <vwui-table [standalone]="true">
    <vwui-table-row>
      <vwui-table-header>Projectnaam</vwui-table-header>
      <vwui-table-header class="hidden sm:table-cell">Plaatsnaam</vwui-table-header>
      <vwui-table-header class="hidden sm:table-cell">Onderneming</vwui-table-header>
      <vwui-table-header class="hidden lg:table-cell">Opleverdatum</vwui-table-header>
      <vwui-table-header  *appHasRole="[authorities.editor, authorities.admin]" class="hidden lg:table-cell">Referentie status</vwui-table-header>
    </vwui-table-row>

    @for (ref of projectReferences; track trackByFn($index, ref)) {
      <vwui-table-row class="group" [clickable]="true" (click)="tableRowSelect(ref)">
        <vwui-table-column class="flex-column">
          <div class="inline-flex items-center">
            <app-photo class="inline-block w-8 h-8 rounded mr-3 group-hover:shadow-sm border group-hover:border-neutral-2"
            [photo]="ref.primaryPhoto" sizes="30px"></app-photo>
            <span class="flex-column__text">{{ref.commercialProjectName || ref.name}}</span>
          </div>
        </vwui-table-column>
        <vwui-table-column class="hidden sm:table-cell">{{ref.city}}</vwui-table-column>
        <vwui-table-column class="hidden sm:table-cell">{{ref.companyName}}</vwui-table-column>
        <vwui-table-column class="hidden lg:table-cell">{{ref.endDate | date:'dd-MM-yyyy'}}</vwui-table-column>
        <vwui-table-column *appHasRole="[authorities.editor, authorities.admin]" class="hidden lg:table-cell">
          <div class="flex flex-column items-center">
            <div class="rounded-full w-1.5 h-1.5 mr-3"
              [class.bg-warning]="ref.status === 'Concept'"
              [class.bg-success]="ref.status === 'Published'"
            ></div>
            {{ref.status | statusTranslate}}
          </div>
        </vwui-table-column>
      </vwui-table-row>
    }
  </vwui-table>
</div>
